export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const LOADING_AUTH = 'LOADING_AUTH';
export const REFRESH_TOkEN = 'REFRESH_TOkEN';
export const THEME = 'THEME';
export const UPDATE_COUNT_SIDEBAR = 'UPDATE_COUNT_SIDEBAR';
